import { APICore, PENSION_URL, CLIENT_SEARCH_URL, DASHBOARD_URL } from './apiCore';

const api = new APICore();

const createPension = (clientId: string, ignorePOA?: boolean, creationReason?: string) => {
    return api.create(`${PENSION_URL}/pension`, { clientId, ignorePOA, creationReason });
};

const deletePension = (pensionId: string) => {
    return api.delete(`${PENSION_URL}/pension/${pensionId}`);
};

const editPension = (pensionId: string, body: any) => {
    const relativeUrl = `/pension/${pensionId}`;
    return api.update(`${PENSION_URL}${relativeUrl}`, body);
};

const getPensionStatuses = async () => {
    const relativeUrl = '/search/enums';
    const result = await api.get(`${CLIENT_SEARCH_URL}${relativeUrl}`);
    const { PensionStatuses } = result;
    return {
        statuses: Object.keys(PensionStatuses),
    };
};

const isPOAValid = async (clientId: string) => {
    return api.get(`${PENSION_URL}/signatures/is-poa-valid?clientId=${clientId}`);
};

const sendSavingsWhatsapp = async () => {
    return api.create(`${PENSION_URL}/pension/send-savings-whatsapp`, {});
};

const getPensionStatusTrackers = (params: { pensionId?: string; clientId?: string }) => {
    const url = `${PENSION_URL}/pension/status-trackers`;
    return api.get(url, params);
};

export { deletePension, createPension, editPension, getPensionStatuses, isPOAValid, sendSavingsWhatsapp, getPensionStatusTrackers };
